import { useCampaignStore } from '@lidea/shared/data-access/core';
import { useQuery } from '@tanstack/react-query';

import { plotKeys } from './../../keys/plot-keys';

export function usePlot(id: number) {
  const campaignId = useCampaignStore((s) => s.campaignId);

  const query = useQuery({
    ...plotKeys.detail(id, campaignId),
    enabled: !!campaignId && id > 0,
  });

  return query;
}

export default usePlot;
